import type { RouteMeta, RouteRecordRaw } from 'vue-router';

import { type ComputedRef, type MaybeRefOrGetter, type Ref, computed, toValue } from 'vue';

export const useAppNavigation = (
  iconMap: Ref<Map<string, string> | undefined>,
  appendIconMap: Ref<Map<string, string | undefined> | undefined>,
  hiddenRouteMap: Ref<Map<string, boolean> | undefined>,
  isRoutePermitted: MaybeRefOrGetter<
    ((meta?: MaybeRefOrGetter<RouteMeta | undefined>) => ComputedRef<boolean>)
    | undefined
  >,
) => {
  const isRoutePermittedFn = toValue(isRoutePermitted) ?? (() => computed(() => true));

  function getIcon(key: string) {
    return iconMap.value?.get(key);
  }

  function getAppendIcon(key: string) {
    return appendIconMap.value?.get(key);
  }

  function getIconsFromRoute(route: RouteRecordRaw) {
    return {
      appendIcon: getAppendIcon(route.name as string || route.path || ''),
      icon: getIcon(route.name as string || route.path || ''),
    };
  }

  function isItemHidden(route: RouteRecordRaw) {
    return hiddenRouteMap.value?.get(route.name as string || route.path || '') ?? false;
  }

  return {
    getAppendIcon,
    getIcon,
    getIconsFromRoute,
    isItemHidden,
    isRoutePermitted: isRoutePermittedFn,
  };
};
